import { Box, Button, CircularProgress } from '@mui/material'
import ImageBanner from 'components/image-banner'
import Loading from 'components/loading'
import LogoTheme from 'components/logo-theme'
import SearchSVG from 'components/svg/search'
import WrapperPermission from 'components/wrapper-permission'
import OrganizationInfo from '../organization-info'
import AuthorizationGroup from './authorization-group'
import AuthorizationOption from './authorization-option'
import { useStyles } from './styles'
import useComponent from './use-component'
import { useHistory } from 'react-router-dom'

const RequestPermission = () => {
  const classes = useStyles()
  const history = useHistory()

  const {
    form: {
      control,
      handleSubmit,
      formState: { isSubmitting },
      setValue,
    },
    isLoading,
    theme,
    sellerOrganization,
    user,
    optionsCount,
    trueOptionsCount,
    checkedValues,
    indeterminateValues,
    onSubmit,
    handleSelectAll,
    handleChange,
    handleGoBack,
    onSubmitTables
  } = useComponent()

  if (isLoading) {
    return (
      <Box className={classes.root}>
        <Loading />
      </Box>
    )
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.mainWrapper}>
        <WrapperPermission>
          <Box
            component='form'
            noValidate
            data-testid='form'
            className={classes.connectBox}
            onSubmit={handleSubmit(onSubmitTables)}
          >
            <LogoTheme />
            <p className={classes.formTitle}>Escolha as Tabelas que gostaria de compartilhar</p>
            <p className={classes.formSubTitle}>
              A {sellerOrganization?.corporateName || 'organização'} quer acessar as tabelas através da Conducco. Isso permitirá
              a Conducco acesso de leitura aos seguintes dados do e-Social:
            </p>

            <OrganizationInfo
              organizationName={user!.organization?.name as string}
              organizationFederalTaxId={user!.organization?.cnpj as string}
            />

            <Box className={classes.authorizationBox}>
              <AuthorizationGroup
                title='Dados selecionados'
                total={optionsCount}
                selected={trueOptionsCount}
                checked={checkedValues}
                interminate={indeterminateValues}
                onChangeAll={handleSelectAll}
              />

              <AuthorizationOption
                title='Cadastro de titulares'
                description='Referem-se aos dados pessoais e profissionais 
                dos colaboradores registrados no sistema.'
                name='cadastraisDosTitulastes'
                control={control}
                isLoading={true}
                setValue={setValue}
                handleChange={handleChange}
              />

              <AuthorizationOption
                title='Cadastro do trabalho de titulares'
                description=''
                control={control}
                name='cadastraisDosDependentes'
                isLoading={isSubmitting}
                setValue={setValue}
                handleChange={handleChange}
              />

              <AuthorizationOption
                title='Empresa de titulares'
                description=''
                control={control}
                name='informacoesDaEmpresa'
                isLoading={isSubmitting}
                setValue={setValue}
                handleChange={handleChange}
              />

              <AuthorizationOption
                title='Cadastro de dependetes'
                description=''
                control={control}
                name='contratosDeTrabalhosDosTitulares'
                isLoading={isSubmitting}
                setValue={setValue}
                handleChange={handleChange}
              />

              <AuthorizationOption
                title='Caracterização de dependetes'
                description=''
                control={control}
                name='historicoDeDadosCadastrais'
                isLoading={isSubmitting}
                setValue={setValue}
                handleChange={handleChange}
              />

              <AuthorizationOption
                title='Historico de cadastro'
                description=''
                control={control}
                name='historicoDeAfastamentos'
                isLoading={isSubmitting}
                setValue={setValue}
                handleChange={handleChange}
              />

              <AuthorizationOption
                title='Histórico trabalhista'
                description=''
                control={control}
                name='historicoDeContratosDeTrabalho'
                isLoading={isSubmitting}
                setValue={setValue}
                handleChange={handleChange}
              />

              <AuthorizationOption
                title='Folhas'
                description=''
                control={control}
                name='informacoesDaFolha'
                isLoading={isSubmitting}
                setValue={setValue}
                handleChange={handleChange}
              />
            </Box>

            <p className={classes.textFoot}>
              A partir da sua aprovação, a {sellerOrganization?.corporateName || 'organização'} e a Conducco utilizarão as
              informações listadas acima, respeitando os Termos de Serviço e as Políticas de Privacidade da plataforma.
              Você pode remover o acesso a qualquer momento solicitando no e-mail suporte@conducco.com.
            </p>

            <Box
              display='flex'
              justifyContent='space-between'
              alignItems='center'
              width='100%'
            >
              <Button
                color='inherit'
                variant='outlined'
                onClick={() => history.push('/datasource-connect')}
                sx={{
                  borderColor: '#000000 !important',
                  color: '#000000 !important',
                  height: '42px',
                  padding: '0 2rem',
                }}
              >
                Voltar
              </Button>
              <Button
                variant='contained'
                type='submit'
                disabled={isSubmitting}
                sx={{
                  height: '42px !important',
                  padding: '0 2rem',
                  fontWeight: '600',
                }}
              >
                {isSubmitting ? (
                  <CircularProgress
                    color='inherit'
                    size={26}
                  />
                ) : (
                  'Autorizar'
                )}
              </Button>
            </Box>
          </Box>
        </WrapperPermission>

        <ImageBanner
          title='Solicitação de acesso aos dados com garantia de sua privacidade e segurança.'
          banner={<SearchSVG />}
        />
      </Box>
    </Box>
  )
}

export default RequestPermission
